/**
 * Created by 赵耀 on 2025/8/11
 * Desc: 学生报到
 */

import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import '../user/PhoneAddPage.css';
import Swiper from 'swiper/dist/js/swiper'
import 'swiper/dist/css/swiper.min.css'
import { Avatar, Carousel, Button } from 'antd'
import { Toast, Modal } from 'antd-mobile'
import { connect } from "react-redux";
import { getIntValue, getSearchParams, getStrValue, isObjEmpty } from "../../utils/common";
import './ChechPreview.css'
import { fetchGet, fetchPost, fetchPostObj } from "../../utils/fetchRequest";
import { _baseURL, API } from "../../configs/api.config";
import ImagesViewer from '../../components/imagesVIewer/index'
import phone_img from '../../style/imgs/phone_icon.png';
import PhoneItem from './PhoneItem';

class ChechPreview extends Component {

    constructor() {
        super()

        this.state = {
            schoolId: 0,
            stuName: null,
            stuNumber: null,
            stuClass: null,
            stuPhone: null,
            ICCID: null,
            idCard: null,
            previewVisible: false,
            previewImage: '',
            description: '',
            selectContentArray: [
                {
                    phone:null,
                    relation:null,
                }
            ],
        }

    }

    componentWillMount() {
    }

    componentDidMount() {

        document.title = "学生报到";
        this.searchParams = getSearchParams(this.props.location.search)

    }

    componentWillUnmount() {

    }

    render() {
        let {previewVisible, stuName, stuNumber, stuClass, ICCID, stuPhone, idCard } = this.state

        return (
            <div className='album-page-root'>
                <div className='head-album-page'>
                    <MenuGroup groupIcon={require('imgs/ic_group_album.png')} groupText='学生报到' />
                </div>

                {/*信息录入*/}
                <div ref={node => this.node = node} style={{fontFamily:"PingFangSC-Regular",letterSpacing:2.5}} className="common-column-layout">
                    <div style={{padding:10}}>
                        <div onChange={this.handelValueCom}>
                            <div  className="item_sty">
                                <div className="left_title">学生姓名</div>
                                <input ref='stuName' className="text-right right_input" type="text" placeholder="请输入" maxLength={6} autoFocus="autoFocus" value={this.state.stuName} />
                            </div>
                            {/*<div className="item_sty">
                                <div className="left_title">卡上学号</div>
                                <input ref='stuNumber' className="text-right right_input" type="text" placeholder="请输入" maxLength={20} autoFocus="autoFocus" value={this.state.stuNumber} />
                            </div>*/}
                            <div className="item_sty">
                                <div className="left_title">班级</div>
                                <input ref='stuClass' className="text-right right_input" type="text" placeholder="请输入" maxLength={6} autoFocus="autoFocus" value={this.state.stuClass} />
                            </div>
                            <div className="item_sty">
                                <div className="left_title">学生电话号</div>
                                <input ref='stuPhone' className="text-right right_input" type="text" placeholder="请输入" maxLength={11} autoFocus="autoFocus" value={this.state.stuPhone} />
                            </div>
                            {/*<div className="item_sty" onChange={this.handelValueCom}>
                                <div className="left_title">学籍号</div>
                                <input ref='stuName' className="text-right right_input" type="text" placeholder="请输入" maxLength={6} autoFocus="autoFocus" value={this.state.stuName} />
                            </div>
                            <div className="item_sty" onChange={this.handelValueCom}>
                                <div className="left_title">年级</div>
                                <input ref='stuName' className="text-right right_input" type="text" placeholder="请输入" maxLength={6} autoFocus="autoFocus" value={this.state.stuName} />
                            </div>
                            <div className="item_sty" onChange={this.handelValueCom}>
                                <div className="left_title">开卡人</div>
                                 <input ref='stuName' className="text-right right_input" type="text" placeholder="请输入" maxLength={6} autoFocus="autoFocus" value={this.state.stuName} />
                            </div>
                            <div className="item_sty" onChange={this.handelValueCom}>
                                <div className="left_title">办卡号码</div>
                                <input ref='stuName' className="text-right right_input" type="text" placeholder="请输入" maxLength={6} autoFocus="autoFocus" value={this.state.stuName} />
                            </div>*/}
                        </div>

                        <div style={{backgroundColor:'#FFF',width:'100%',padding:10,borderRadius:10}}>
                            <div className="leave_row_sty">
                                <div>
                                    {this.state.selectContentArray.map((itemata,index) => <PhoneItem index ={index} key={index} itemata = {itemata} handelRItem={this.handelRItem} removeSItem={this.removeSItem}></PhoneItem>)}
                                    <div onClick={this.addPhoneItem} className="text-center" style={{color:"#0CE11D",fontSize:12,margin:10}}>+ <span style={{color:"#666666",borderBottom:"1px #000 solid"}}>添加家长号码</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{textAlign: 'center'}}><Button className='commonButton' type='primary' style={{margin: '35px',borderRadius:30,justifyContent: 'center'}}
                         onClick={this.onNextClick}>提交</Button></div>
            </div>
        )
    }

    handlePreview = (url, index) => {
        this.setState({
            previewImage: url,
            previewVisible: true,
            previewIndex: index
        });
    }

    handleCancel = () => this.setState({ previewVisible: false })

    onNextClick = (index, ruleId) => {
        if(ruleId === undefined){
            ruleId = 0
        }
        let appId = this.searchParams.appId;
        let schoolId = this.searchParams.schoolId;
        let gradeId = this.searchParams.gradeId;
        let parentsDOS = this.state.selectContentArray;
        this.onSubmitClick();
       // this.props.history.push('/chechApply/' + appId + '/' + schoolId + '/' + gradeId);

    }

    onSubmitClick = () => {

        for(let i=0;i<this.state.selectContentArray.length;i++){
            if (this.state.selectContentArray[i].phone == null || this.state.selectContentArray[i].phone.trim().length == 0){
                Toast.show('电话明细存在未输入项')
                return
            }
        }

        var params = {
            schoolId: this.searchParams.schoolId,
            stuName: this.state.stuName,
            stuNumber: this.state.stuNumber,
            stuClass: this.state.stuClass,
            gradeName: this.searchParams.gradeName,
            stuPhone: this.state.stuPhone,
            ICCID: this.state.ICCID,
            idCard: this.state.idCard,
            parentsDOS:this.state.selectContentArray
        }

        this.isRequesting = true
        fetchPost(API.PARENT_PHONE_NAME_CREATED, {
            dataString:JSON.stringify(params)
        }, {}).then((response) => {
            console.log('response', response)
            this.isRequesting = false
            if (response.success) {
                this.isRequesting = true
                Toast.show(response.data, 1)
                
                this.backTask = setTimeout(() => {
                    this.props.history.goBack()
                }, 1000)
            }
            // 错错误的 this.props.history.push('https://school-wechat.ydyhz.com/bindMenu/app/wxbf86c8f77700b3af');
        }).catch((error) => {
            this.isRequesting = false
            console.log('error', error)
            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常', 2)
            }
        })
    }

    handelRItem = (itemObject,index)=>{
        console.log('itemObject',itemObject)
        console.log('index',index)
        let selectContentArray = this.state.selectContentArray
        selectContentArray[index] = itemObject
        this.setState({
            selectContentArray:selectContentArray
        })
    }

    removeSItem = (index)=>{
        if(this.state.selectContentArray.length == 1){
            return
        }
        let selectContentArray = this.state.selectContentArray
        selectContentArray.splice(index,1)
        this.setState({
            selectContentArray
        })
    }

    addPhoneItem = (event)=>{
        let selectContentArray =  [...this.state.selectContentArray,1];
        this.setState({
            selectContentArray
        })
    }
    handelValueCom = (event) => {
        //获取用户名的值
         let stuName = this.refs.stuName.value;
         let stuClass = this.refs.stuClass.value;
         let stuPhone = this.refs.stuPhone.value;
         //获得内容的值
         this.setState({
              stuName: stuName,
              stuClass: stuClass,
              stuPhone: stuPhone,
        })
    }
}

class MenuGroup extends Component {
    render() {
        return (
            <div className='album-group-item-layout'>
                {/*<img className='home-group-item-icon' src={this.props.groupIcon}/>*/}
                <span className='album-group-item-text'>{this.props.groupText}</span>
            </div>
        )
    }
}

let mapStateToProps = (state) => ({
    userInfo: { ...state.redUserInfo }
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(ChechPreview)
